import { render, staticRenderFns } from "./TitleBlock.vue?vue&type=template&id=72915b73&"
import script from "./TitleBlock.vue?vue&type=script&lang=ts&"
export * from "./TitleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBlock.vue?vue&type=style&index=0&id=72915b73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports